import { BasicWithLibelleModel } from '../basic/basicWithLibelle.model';
import { BasicModel } from '../basic/basic.model';
import { ActiviteModel } from './activite.model';

export class SocieteModel extends BasicModel implements BasicWithLibelleModel {
    // max-length 6
    code: string;
    // max-length 30
    libelle: string;
    // max-length 7
    codeStar: string;
    // max-length 12
    codeCompta: string;
    // max-length 50
    capitalSocial: string;
    // max-length 50
    rsc: string;
    // max-length 9
    siren: string;
    // max-length 15
    tvaIntraComm: string;
    idActivite: number;
    activite: ActiviteModel;
    montantMaxAutoValidBC: number;

}

export class SocieteNode extends BasicModel implements BasicWithLibelleModel {
    // max-length 7
    code: string;
    // max-length 30
    libelle: string;
    // max-length 6
    children?: SocieteNode[];

    societe?: SocieteModel;
}
